import React from 'react'
import {Audit, AuditDocument} from '../types/audit.types'
import {Link} from 'react-router-dom'

interface AuditActionsProps {
  audit: Audit
  currentUserRole?: string
  downloadLoading: boolean
  selectedAuditId: string
  onEditAudit: (auditId: string) => void
  onUploadReport: (auditId: string) => void
  onMarkComplete: (auditId: string, audit: Audit) => void
  onDownloadAuditReport: (auditId: string, auditDocument: AuditDocument) => void
  onDownloadReport: (auditId: string, dataroomFolderId: string, folderName: string) => void
  onDelete: (audit: Audit) => void
  disabled: boolean
  currentAuditContext?: any
  isFutureDate?: boolean
  onEditAuditors: (auditId: string) => void
}

const AuditActions: React.FC<AuditActionsProps> = ({
  audit,
  currentUserRole,
  downloadLoading,
  selectedAuditId,
  onEditAudit,
  onUploadReport,
  onMarkComplete,
  onDownloadAuditReport,
  onDownloadReport,
  onDelete,
  disabled,
  currentAuditContext,
  isFutureDate,
  onEditAuditors,
}) => {
  return (
    <>
      <div className='dropdown'>
        <button
          className='btn btn-sm btn-icon'
          type='button'
          id='dropdownMenu2'
          data-bs-toggle='dropdown'
          aria-haspopup='true'
          aria-expanded='false'
          style={{border: '1px solid #d1d5db'}}
          disabled={disabled}
        >
          {downloadLoading && audit.id === selectedAuditId ? (
            <div
              className='spinner-border'
              role='status'
              style={{
                width: '1rem',
                height: '1rem',
              }}
            >
              <span className='visually-hidden'>Loading...</span>
            </div>
          ) : (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='16'
              height='16'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              stroke-width='2'
              stroke-linecap='round'
              stroke-linejoin='round'
              className='icon icon-tabler icons-tabler-outline icon-tabler-dots'
            >
              <path stroke='none' d='M0 0h24v24H0z' fill='none' />
              <path d='M5 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0' />
              <path d='M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0' />
              <path d='M19 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0' />
            </svg>
          )}
        </button>
        <ul className='dropdown-menu' aria-labelledby='dropdownMenu2'>
          {isFutureDate && currentUserRole === 'Auditor' ? (
            <li>
              <button
                className='dropdown-item text-hover-primary'
                type='button'
                style={{color: '#6b7280'}}
                disabled
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='16'
                  height='16'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  className='icon icon-tabler icons-tabler-outline icon-tabler-share me-2 mb-1'
                >
                  <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                  <path d='M6 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0' />
                  <path d='M18 6m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0' />
                  <path d='M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0' />
                  <path d='M8.59 13.51l6.83 3.98' />
                  <path d='M15.41 6.51l-6.82 3.99' />
                </svg>
                Share Evidences
              </button>
            </li>
          ) : (
            <li>
              <Link
                to={`/data-room?folderName=${audit.auditTitle}`}
                className='dropdown-item text-hover-primary'
              >
                {audit.auditor ? (
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='16'
                    height='16'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    stroke-width='2'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                    className='icon icon-tabler icons-tabler-outline icon-tabler-eye me-2 mb-1'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0' />
                    <path d='M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6' />
                  </svg>
                ) : (
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='16'
                    height='16'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    className='icon icon-tabler icons-tabler-outline icon-tabler-share me-2 mb-1'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M6 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0' />
                    <path d='M18 6m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0' />
                    <path d='M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0' />
                    <path d='M8.59 13.51l6.83 3.98' />
                    <path d='M15.41 6.51l-6.82 3.99' />
                  </svg>
                )}
                {audit.auditor ? 'View Evidences' : 'Share Evidences'}
              </Link>
            </li>
          )}
          <li>
            <button
              className='dropdown-item text-hover-primary'
              type='button'
              style={{color: '#262626'}}
              onClick={() => onEditAudit(audit.id)}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
                className='icon icon-tabler icons-tabler-outline icon-tabler-edit me-2 mb-1'
              >
                <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                <path d='M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1' />
                <path d='M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z' />
                <path d='M16 5l3 3' />
              </svg>
              {currentUserRole === 'Auditor' ? 'View Audit Details' : 'Edit Audit Dates'}
            </button>
          </li>
          {(currentUserRole === 'Auditor' || currentAuditContext) && (
          <li>
            <button
              className='dropdown-item text-hover-primary'
              type='button'
              style={{color: '#262626'}}
              onClick={() => onEditAuditors(audit.id)}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                stroke-width='2'
                stroke-linecap='round'
                stroke-linejoin='round'
                className='icon icon-tabler icons-tabler-outline icon-tabler-users-plus me-2 mb-1'
              >
                <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                <path d='M5 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0' />
                <path d='M3 21v-2a4 4 0 0 1 4 -4h4c.96 0 1.84 .338 2.53 .901' />
                <path d='M16 3.13a4 4 0 0 1 0 7.75' />
                <path d='M16 19h6' />
                <path d='M19 16v6' />
              </svg>
                Edit Auditors
              </button>
            </li>
          )}
          {audit.audit_documents &&
            audit.audit_documents.length > 0 &&
            audit.status === 'Completed' && (
              <li>
                <button
                  className='dropdown-item text-hover-primary'
                  type='button'
                  style={{color: '#262626'}}
                  onClick={() => onDownloadAuditReport(audit.id, audit.audit_documents![0])}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='16'
                    height='16'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    className='icon icon-tabler icons-tabler-outline icon-tabler-download me-2 mb-1'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2' />
                    <path d='M7 11l5 5l5 -5' />
                    <path d='M12 4l0 12' />
                  </svg>
                  Export Audit Report
                </button>
              </li>
            )}
          <li>
            <button
              className='dropdown-item text-hover-primary'
              type='button'
              style={{color: '#262626'}}
              onClick={() =>
                onDownloadReport(
                  audit.id,
                  audit.dataroomFolderID || '',
                  audit.auditEvidenceFolderName || ''
                )
              }
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
                className='icon icon-tabler icons-tabler-outline icon-tabler-download me-2 mb-1'
              >
                <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                <path d='M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2' />
                <path d='M7 11l5 5l5 -5' />
                <path d='M12 4l0 12' />
              </svg>
              Export Documents
            </button>
          </li>
          {currentUserRole !== 'Auditor' && (
            <>
              <div className='separator my-2'></div>
              <li>
                <button
                  className={`dropdown-item ${currentAuditContext ? 'text-gray-500' : ''}`}
                  type='button'
                  style={{color: '#dc2626'}}
                  onClick={() => onDelete(audit)}
                  disabled={currentAuditContext}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='16'
                    height='16'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    className='icon icon-tabler icons-tabler-outline icon-tabler-trash me-2 mb-1'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M4 7l16 0' />
                    <path d='M10 11l0 6' />
                    <path d='M14 11l0 6' />
                    <path d='M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12' />
                    <path d='M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3' />
                  </svg>
                  Delete Audit
                </button>
              </li>
            </>
          )}
        </ul>
      </div>
    </>
  )
}

export default AuditActions
